export const path = {
  ROOT: "/",
  LOGIN: "/login",
  LIST: "/list",
  LISTGRAPHQL: "/listgraphql",
  POKEDEX: "/pokedex",
}
